import { baseSizes, baseTheme } from 'Shared/frontend/BaseTheme';
import { merge } from 'Shared/frontend/merge';
import { ITheme } from 'Shared/frontend/ThemeProvider';

const palette = {
	background: 'black',
	text: '#E2E2E2',
	feature: '#FCB03B',

	/* Eg the mobile nav colour */
	dimBackground: '#1C1513'
};

const fonts = {
	text: '"Noto Serif", serif',
	heading: '"Kiwi Maru", serif',
	buttons: '"Kiwi Maru", serif',
	desktopNav: '"Kiwi Maru", serif',
	mobileNav: '"Kiwi Maru", serif',
	subNav: '"Kiwi Maru", serif',
}


export function theDockTheme():ITheme
{
	const base = baseTheme(baseSizes,palette,fonts);

	const settings = merge(base, <Partial<ITheme>>{

//XXX NB same as The Townie...
		footer: {
			divider: {
				borderColor: palette.feature
			},

			title: {
				color: palette.feature
			},
		},

		poster: {
			dateBar: {
				color: palette.dimBackground
			},

			photoPoster: {
				inlineName: {
					color: palette.feature
				}
			},

			detailsButton: {
				textColor: palette.feature
			}
		},

		event: {
			artist: {
				heading: {
					color: palette.feature,
					fontFamily: 'sans-serif'
				},
				wide: {
					nameAndTime: {
						color: palette.feature
					}
				},
				narrow: {
					nameAndTime: {
						backgroundColor: palette.feature
					}
				}, 
				genresAndLocation: {
					color: palette.feature
				} 
			}
		},

		events: {
			heading: {
				color: palette.feature
			}
		},

		contact: {
			heading: {
				color: palette.feature
			}
		},

		button: {
			backgroundColor: palette.dimBackground,
			borderRadius: '0.4em'
		},

		subNavButton: {
			borderRadius: '0.4em'
		},

		heading: {
			color: palette.feature
		},
	});

	// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
	return settings;
};

